import {
    Button, Input, Space,
} from 'antd';

import { SEARCH_INPUT_WIDTH } from '@/constants';

type SearchInputProps = {
    placeholder: string;
    width?: number;
    value?: string;
    onSearch: (value: string) => void;
    onChange?: (value: string) => void;
    disabled?: boolean;
    className?: string;
};

export const SearchInput = ({ placeholder, width = SEARCH_INPUT_WIDTH, value, onSearch, onChange, disabled, className }: SearchInputProps) => {
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearch(value || '');
        }
    };

    return (
        <Space.Compact className={className} style={{ width }}>
            <Input
                placeholder={placeholder}
                allowClear
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={disabled}
            />
            <Button
                type="primary"
                onClick={() => onSearch(value || '')}
                disabled={disabled}
            >
                Пошук
            </Button>
        </Space.Compact>
    );
};
